import React, { useState } from "react";
import PropTypes from "prop-types";
import { Link, useLocation } from "react-router-dom";

import { Collapse, List, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";

import styles from "./ListDrawer.module.scss";
import { Settings, ExpandLess, ExpandMore } from "@mui/icons-material";
import { iconTables } from "assets/icons";

export const InsideDrawerNav = ({
    menu = {},
    route = '',
    level = 0,
    // availableRoutes = [],
    handleClick = () => { },
}) => {
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const location = useLocation();
    const isSelected = location.pathname === `/${route}${menu.route}`;

    if (menu.isGroup) {
        return (
            <>
                <ListItemButton
                    className={styles.itemList}
                    onClick={() => setIsDrawerOpen(!isDrawerOpen)} sx={{ pl: 3 + level }}
                >
                    <ListItemIcon>
                        <Settings className={`${styles.iconsDrawer} ${isDrawerOpen ? styles.iconsDrawerOpen : ""}`} />
                    </ListItemIcon>
                    <ListItemText className={isDrawerOpen ? styles.textColorSelect : styles.textColor}>
                        {menu.wordKey}
                    </ListItemText>
                    {isDrawerOpen
                        ? <ExpandLess className={styles.expandOpen} />
                        : <ExpandMore className={styles.expandClosed} />
                    }
                </ListItemButton>
                <Collapse in={isDrawerOpen} >
                    <List>
                        {menu.routes.map((item) => (
                            <InsideDrawerNav
                                key={item.route}
                                menu={item}
                                route={`${route}${menu.route}`}
                                className={styles.link}
                                handleClick={handleClick}
                                level={level + 1}
                            />
                        ))}
                    </List>
                </Collapse>
            </>
        )
    }

    return (
        <Link
            className={styles.link}
            to={menu?.route?.startsWith('/') ? `${route}${menu.route}` : `/${menu.route}`}
        >
            <ListItemButton
                onClick={handleClick}
                sx={{ pl: 3 + level }}
            >
                <ListItemIcon>
                    <img
                        alt="Icono"
                        className={`${styles.iconsDrawer} ${isSelected ? styles.iconsDrawerOpen : ""}`}
                        src={iconTables}
                    />
                </ListItemIcon>
                <ListItemText className={isSelected ? styles.textColorSelect : styles.textColor}>
                    {menu.wordKey}
                </ListItemText>
            </ListItemButton>
        </Link>
    );
};

InsideDrawerNav.propTypes = {
    menu: PropTypes.shape({
        route: PropTypes.string.isRequired,
        wordKey: PropTypes.string.isRequired,
        isGroup: PropTypes.bool,
        routes: PropTypes.array,
    }),
    route: PropTypes.string,
    level: PropTypes.number,
    handleClick: PropTypes.func,
};
